var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24.002,
    viewBox: "0 0 21 24.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bell-regular",
    d: "M10.522,0a1.5,1.5,0,0,0-1.5,1.5v.9a7.5,7.5,0,0,0-6,7.351v1.191A9.384,9.384,0,0,1,.968,16.8l-.7.877A1.125,1.125,0,0,0,1.146,19.5H19.9a1.125,1.125,0,0,0,.877-1.828l-.7-.872a9.407,9.407,0,0,1-2.053-5.86V9.751a7.5,7.5,0,0,0-6-7.351V1.5A1.5,1.5,0,0,0,10.522,0Zm0,4.5a5.248,5.248,0,0,1,5.251,5.251v1.191a11.643,11.643,0,0,0,1.861,6.31H3.411a11.643,11.643,0,0,0,1.861-6.31V9.751A5.248,5.248,0,0,1,10.522,4.5Zm3,16.5h-6a3,3,0,1,0,6,0Z",
    transform: "translate(-0.022)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon2);
export default __webpack_public_path__ + "static/media/notifications-icon2.5f0b09fb16b7946764fa0a7d671d37d8.svg";
export { ForwardRef as ReactComponent };